import api from './base'

export default {
  getAll ({ businessUnitId }) {
    return api().get(`company/business_units/${businessUnitId}/levels`)
  },
  getById ({ businessUnitId, id }) {
    return api().get(`company/business_units/${businessUnitId}/levels/${id}`)
  },
  save ({ businessUnitId, item }) {
    return api().put(`company/business_units/${businessUnitId}/levels`, item)
  },
  delete ({ businessUnitId, id }) {
    return api().delete(`company/business_units/${businessUnitId}/levels/${id}`)
  },
  setSortOrder ({ businessUnitId, levelId, sortOrder }) {
    return api().put(`company/business_units/${businessUnitId}/levels/${levelId}/sort_order`, { sort_order: sortOrder })
  },
  getAllCategories ({ businessUnitId, levelId }) {
    return api().get(`company/business_units/${businessUnitId}/levels/${levelId}/categories`)
  },
  getCategoryById ({ businessUnitId, levelId, categoryId }) {
    return api().get(`company/business_units/${businessUnitId}/levels/${levelId}/categories/${categoryId}`)
  },
  saveCategory ({ businessUnitId, levelId, categoryId }) {
    return api().put(`company/business_units/${businessUnitId}/levels/${levelId}/categories`, { category: categoryId })
  },
  deleteCategory ({ businessUnitId, levelId, categoryId }) {
    return api().delete(`company/business_units/${businessUnitId}/levels/${levelId}/categories/${categoryId}`)
  },
  setCategorySortOrder ({ businessUnitId, levelId, categoryId, sortOrder }) {
    return api().put(`company/business_units/${businessUnitId}/levels/${levelId}/categories/${categoryId}/sort_order`, { sort_order: sortOrder })
  },
  getAllArticles ({ businessUnitId, levelId }) {
    return api().get(`company/business_units/${businessUnitId}/levels/${levelId}/articles`)
  },
  getArticleById ({ businessUnitId, levelId, articleId }) {
    return api().get(`company/business_units/${businessUnitId}/levels/${levelId}/articles/${articleId}`)
  },
  saveArticle ({ businessUnitId, levelId, articleId }) {
    return api().put(`company/business_units/${businessUnitId}/levels/${levelId}/articles`, { article: articleId })
  },
  deleteArticle ({ businessUnitId, levelId, articleId }) {
    return api().delete(`company/business_units/${businessUnitId}/levels/${levelId}/articles/${articleId}`)
  }
}
